import {
    defer,
    delayWhen,
    MonoTypeOperatorFunction,
    Observable,
    timer,
} from "rxjs";

const SKELETON_THRESHOLD_MS = 150;
const SKELETON_MINIMUM_VISIBLE_MS = 400;

interface SkeletonTimingOptions {
    thresholdMs?: number;
    minimumVisibleMs?: number;
}

/**
 * Fast responses pass through immediately. Once a request crosses the visual
 * threshold, its successful result waits just long enough to prevent a
 * distracting skeleton flash.
 */
export function withSkeletonTiming<T>(
    options: SkeletonTimingOptions = {}
): MonoTypeOperatorFunction<T> {
    const thresholdMs = options.thresholdMs ?? SKELETON_THRESHOLD_MS;
    const minimumVisibleMs =
        options.minimumVisibleMs ?? SKELETON_MINIMUM_VISIBLE_MS;
    return (source: Observable<T>) =>
        defer(() => {
            const startedAt = Date.now();
            return source.pipe(
                delayWhen(() => {
                    const elapsed = Date.now() - startedAt;
                    if (elapsed < thresholdMs) return timer(0);
                    return timer(
                        Math.max(0, thresholdMs + minimumVisibleMs - elapsed)
                    );
                })
            );
        });
}
